import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import './simpleField.sass'

const improveId = id => id.replace(/\[/g, '_').replace(/\]/g, '')

export default class SimpleField extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    name: PropTypes.string.isRequired,
    type: PropTypes.string,
    value: PropTypes.string,
    placeholder: PropTypes.string,
    mask: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    autocomplete: PropTypes.bool,
    autofocus: PropTypes.bool,
    isInvalid: PropTypes.bool,
    onChange: PropTypes.func,
    inputRef: PropTypes.shape({
      current: PropTypes.instanceOf(window.Element),
    }),
  }

  static defaultProps = {
    className: '',
    type: 'text',
    value: '',
    placeholder: '',
    mask: null,
    autocomplete: true,
    autofocus: false,
    isInvalid: false,
    onChange: null,
    inputRef: null,
  }

  handleChange = e => {
    if (this.props.mask) {
      let caretPosition = e.target.selectionEnd

      e.target.value = this.maskValue(e.target.value)

      if (
        e.target.value.charAt(caretPosition - 1) === ' ' &&
        (!e.nativeEvent.inputType ||
          (e.nativeEvent.inputType && e.nativeEvent.inputType === 'insertText'))
      ) {
        caretPosition += 1
      }

      e.target.setSelectionRange(caretPosition, caretPosition)
    }

    if (typeof this.props.onChange === 'function') {
      this.props.onChange(e)
    } else {
      this.props.value = e.target.value
    }
  }

  maskValue(value) {
    const { mask } = this.props

    if (mask === 'number') {
      const matches = value.match(/\d+/g)
      value = matches ? matches.join('') : ''
    }

    if (typeof mask === 'function') {
      value = mask(value)
    }

    return value
  }

  prepareProps() {
    // eslint-disable-next-line
    const { isInvalid, className, mask, autocomplete, autofocus, inputRef, ...rest } = this.props
    return {
      ...rest,
      ...(!this.props.autocomplete && { autoComplete: 'nope' }),
    }
  }

  render() {
    return (
      <input
        {...this.prepareProps()}
        className={classNames('simple-field', this.props.className, {
          'is-invalid': this.props.isInvalid,
        })}
        autoFocus={this.props.autofocus}
        id={improveId(this.props.name)}
        placeholder={this.props.placeholder}
        onChange={this.handleChange}
        ref={this.props.inputRef || null}
      />
    )
  }
}
